import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {useRouteMatch} from 'react-router-dom';
import Checkbox from '@/UIKit/component/checkbox/Checkbox';
import Window from '@/UIKit/component/window/window';
import Pushka from '@/UIKit/component/window/template/pushka';
import {API} from '@/api/API';
import './PaymentMethods.scss';
import {postData, postDataAutch} from "@/utils/sendData";
import Notification from "@/UIKit/component/notification/notification";
import Toggletip from "@/UIKit/component/toggletip/toggletip";
import QuestionIcon from "@/assets/images/icons/16/question-circle.svg";
import ReactHtmlParser from "html-react-parser";
import {Button, Modal, Input, Notify, Preloader} from "uikit";
import ReCAPTCHA from 'react-google-recaptcha';

const PaymentMethods = () => {
    const links = {
        docs: {
            href: 'https://events.nethouse.ru/help/kak-nastroit-integraciyu-pushkinskoj-karty/',
            target: '_blank'
        },
    }

    const sberModalFields = {
        name: {
            value: null,
            error: null
        },
        email: {
            value: null,
            error: null
        },
        detail: {
            value: null,
            error: null,
        },
        sitekey: {
            value: null,
            error: null,
        }
    }

    const router = useRouteMatch()
    const pushka = useRef(null)
    const containerRef = useRef(null)
    const culture_bit = 8

    const admin = useSelector(state => state.admin)
    const [methods, setMethods] = useState([])
    const [preloader, setPreloader] = useState(false)
    const [status, setStatus] = useState(false)
    const [sberModal, setSberModal] = useState(false)
    const [sberModerationData, setSberModerationData] = useState({...sberModalFields})
    const gResponseRef = useRef(null);

    useEffect(() => {
        setPreloader(true)
    }, [])

    useEffect(() => {
        if (admin.constants['payment_types']) initPaymentTypesList(admin.constants['payment_types'])
    }, [admin.constants['payment_types']])

    useEffect(() => {
        if (sberModerationData.sitekey.value) {
            recaptchaAction()
        }
    }, [sberModerationData.sitekey.value]);

    /* Инициализация списка методов оплаты */
    const initPaymentTypesList = (data) => {
        let current = admin.event['payment_types']
        data = data.map((item) => ({key: Number(item.id), name: item.name, comment: item.comment, isChecked: Boolean(item.id & current)}))
        setMethods(data)
        setPreloader(false)
    }

    /* Смена значения метода оплаты */
    const handleCheckbox = async (boolean, idx) => {
        let data, updated, response, arr

        data = JSON.parse(JSON.stringify(methods))
        updated = data.map((method, method_idx) => method_idx === idx ? {...method, isChecked: boolean} : method)
        if (!updated.filter(x => x.isChecked).length) {
            showTopMessage('warning', 'small', 'Невозможно выполнить операцию', 'Как минимум один из способов оплаты должен быть выбран')
            return
        }

        setPreloader(true)
        arr = updated.map(x => x.isChecked ? x.key : null).filter(x => x ?? x)
        response = await requestPaymentMethods(null, arr, updated)

        /* Ответ не был получен */
        if (!response) {
            showTopMessage('error', 'small', 'Произошла ошибка', 'Сервер не отвечает')
            return
        }

        if (response.message && response.errors && arr.includes(256)) {
            setSberModal(true)
        }

        /* Метод оплаты Пушкинской картой успешно установился без вызова модального окна */
        if (data[idx].key & culture_bit && !data[idx].isChecked && response.success) {
            showTopMessage('success', 'large', 'Операция выполнена успешно', 'Оплата Пушкинской картой была успешно подключена')
        }

        /* Получена ошибка, необходимо заполнить поле cultureEventId */
        if (data[idx].key & culture_bit && !data[idx].isChecked && response.errors && !response.errors['paymentType.3']) {
            setStatus(true)
        }

        /* Получена ошибка, необходимо установить для события даты начала/окончания или добавить сеансы */
        if (data[idx].key & culture_bit && !data[idx].isChecked && response.errors && response.errors['paymentType.3']) {
            showTopMessage('warning', 'large', 'Невозможно выполнить операцию', response.errors['paymentType.3'])
        }

        if (!data[idx].isChecked && response.errors && Object.keys(response.errors).map(x => x.includes('paymentType.'))) {
            //..
        }

        if (response.success) {
            setMethods(updated)
        }

        setPreloader(false)
    }

    /* Запрос на изменение методов оплаты в API */
    const requestPaymentMethods = async (data, params, updated) => {
        let event_id, url, method, is_course, response

        is_course = router.params.type_event_id !== 'events'
        event_id = router.params.id
        console.log(`init: ${params}`)
        params = params.map((type, index) => `paymentType[${index}]=${type}`).join('&')
        url = API.changePaymentMethod.path(is_course, event_id, params)
        method = API.changePaymentMethod.method

        try {
            response = await postData(data, url, method);
        } catch (e) {
            response = e.response || {}
        }

        return response.data
    }

    /* Проверка на деактивированное состояние чекбокса */
    // const checkDisabledCheckboxes = (method) => {
    //     let count = methods.map(x => x.isChecked ? x.key : null).filter(x => x ?? x).length
    //     return (count <= 1 && method.isChecked) || preloader
    // }

    /* Активировать метод "Пушкинская карта" */
    const handleSubmit = async (data) => {
        let copied, response, prepare

        copied = JSON.parse(JSON.stringify(methods))
        copied.find(x => x.key == culture_bit).isChecked = true
        prepare = {}
        Object.entries(data).map(([x, i]) => prepare[x] = i.value)
        response = await requestPaymentMethods(prepare, copied.map(x => x.isChecked ? x.key : null).filter(x => x ?? x), copied)
        return response
    }

    const handleRequestModeration = async () => {
        let data

        data = Object.fromEntries(Object.entries(sberModerationData).map(([key, {value}]) => value ? [key, value] : null).filter((x) => x !== null))
        data = {...data, event_id: router.params.id}

        if (gResponseRef.current) {
            data = {...data, 'g-recaptcha-response': gResponseRef.current};
            delete data.sitekey;
        }

        try {
            const response = await postDataAutch(data, API.feedbackRequisite.path(41), API.feedbackRequisite.method, null)
            response.data?.key ?  setSberModerationData(prev => ({
                ...prev,
                sitekey: {...prev.sitekey, value: response.data.key}
            })) : null
            response.data?.success ? setSberModerationData(prev => ({
                ...prev,
                detail: {...prev.detail, value: response.data.message},
                email: {...prev.email, error: null},
                name: {...prev.name, error: null}
            })) : null
        } catch ({response}) {
            response.error?.status === 422 ? Object.entries(response.data.errors).forEach(([field, value]) => setSberModerationData(prev => ({
                ...prev,
                [field]: {...prev[field], error: value[0]}
            }))) : null
            showTopMessage('error', 'large', 'Ошибка при отправке формы', 'Произошла ошибка, повторите попытку')
        }
    }

    const recaptchaAction = async () => {
        gResponseRef.current = await gResponseRef.current.executeAsync()
        await handleRequestModeration()
    }

    /* Закрыть модальное окно */
    const handleClose = (result) => {
        result === true ? setMethods(methods.filter(x => x.key == culture_bit ? x.isChecked = true : x)) : null
        pushka.current.handleClose()
    }

    /* Рендер модального окна подключения пушкинской карты */
    const renderPushkaModal = () => {
        return <Window
            status={status}
            setStatus={setStatus}
            ref={pushka}
            dismissible={true}
            esc={true}
            selector={'nh-window__pushka'}
            content={<Pushka
                links={links}
                onClose={handleClose}
                onSubmit={handleSubmit}
            />}
        />
    }

    return (
        <div className={'ui-cp__container'} ref={containerRef}>
            {renderPushkaModal()}
            <div className="ui-cp__row ui-cp__row_md">
                <div className="ui-cp__payment-methods">
                    <h4 className={'settings-main-title'}>Способы оплаты</h4>
                    <div className={'ui-cp__payment-methods__grid'}>
                        {methods.length ? methods.map((method, method_idx) => <div
                            key={method_idx}
                            className={'ui-cp__payment-methods__checkbox'}>
                            <Checkbox
                                id={`payment-key__${method.key}`}
                                disabled={preloader}
                                checked={method.isChecked}
                                size={'medium'}
                                value={method.name}
                                onChange={(e) => handleCheckbox(e, method_idx)}
                            />
                            {method.comment !== null ? <Toggletip
                                parent={document.querySelector('main')}
                                content={ReactHtmlParser(method.comment)}>
                                <button className={'ui-cp__payment-methods__toggle'}><QuestionIcon/></button>
                            </Toggletip> : null}
                        </div>) : null}
                        {Object.values(admin.constants).length && Object.values(admin.constants?.payment_types)?.length === 0 ?
                            <Notification type={'warning'}
                                          value={'Для текущего события отсутствуют способы оплаты'}/> : null}
                        {!methods.length && preloader ? <Preloader/> : null}
                    </div>
                </div>
            </div>
            <Modal
                active={sberModal}
                onActive={setSberModal}
                style={{padding: '16px', maxWidth: '650px', width: '100%'}}
                onEscape={(event) => console.log(event)}
                onMissClick={(event) => console.log(event)}
                className={"ui-cp__payment-methods__modal-sber"}>
                <div className="ui-cp__payment-methods__modal-header">
                    <h6>Подключения рассрочки от Сбера</h6>
                </div>
                <div className="ui-cp__payment-methods__modal-body">
                    <p>Подключение оплаты в рассрочку от Сбербанка требуется модерация. Укажите свой email и мы сообщим вам о результатах модерации</p>
                    <Input
                        size={'medium'}
                        value={sberModerationData.name.value}
                        error={sberModerationData.name?.error}
                        onChange={(e) => setSberModerationData(prev => ({...prev, name: {...prev.name, value: e.target.value}}))}
                        label={'ФИО'}/>
                    <Input
                        size={'medium'}
                        value={sberModerationData.email.value}
                        error={sberModerationData.email?.error}
                        onChange={(e) => setSberModerationData(prev => ({...prev, email: {...prev.email, value: e.target.value}}))}
                        label={'Email'}/>
                </div>
                {sberModerationData.sitekey.value && !sberModerationData.detail.value ? (
                    <ReCAPTCHA
                        sitekey={String(sberModerationData.sitekey.value)}
                        size={'invisible'}
                        ref={gResponseRef}
                    />
                ) : null}
                {!sberModerationData.detail.value
                    ? <div className="ui-cp__payment-methods__modal-footer">
                        <Button type={'tertiary'} theme={'ghost'} onClick={() => setSberModal(false)}>
                            отменить
                        </Button>
                        <Button type={'primary'} theme={'default'} onClick={handleRequestModeration}>
                            отправить
                        </Button>
                    </div>
                    : <Notify type={'success'}>{sberModerationData.detail.value}</Notify>
                }
            </Modal>
        </div>
    );
};

export default PaymentMethods;
